import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["maxColumns", "offeringId", "responsive", "searchQuery"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { useTrackEvent } from 'marketplace-ui-tracking';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { searchAssets as ecosystemSearchAssets } from '../../clients/ecosystemClient';
import { searchAssets as marketplaceSearchAssets } from '../../clients/marketplaceSearchClient';
import StorefrontSection from '../../components/storefront/StorefrontSection';
import { useOfferingType } from '../../context/OfferingTypeContext';
import RouterAssetCard from '../RouterAssetCard';

// @ts-expect-error module is untyped
import { getIsUngatedForMarketplaceSearch } from '../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
const SectionLoadingComponent = () => {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    minHeight: 150,
    layout: "centered"
  });
};
const ErrorComponent = () => {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.recommendations.error"
    })
  });
};
export default function AssetResultsSectionDataContainer(_ref) {
  let {
      maxColumns,
      offeringId,
      responsive,
      searchQuery
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackInteraction,
    trackPageview
  } = rest;
  const offeringType = useOfferingType();
  const [requestState, setRequestState] = useState(RequestState.UNINITIALIZED);
  const [searchResponse, setSearchResponse] = useState(null);
  const {
    trackEvent: trackCoreEvent
  } = useTrackEvent();
  const isUngatedForMarketplaceSearch = useSelector(getIsUngatedForMarketplaceSearch);
  const searchAssets = isUngatedForMarketplaceSearch ? marketplaceSearchAssets : ecosystemSearchAssets;
  useEffect(() => {
    if (requestState === RequestState.UNINITIALIZED) {
      setRequestState(RequestState.PENDING);
      const request = Promise.resolve(searchQuery).then(query => searchAssets(query));
      request.then(([resp]) => {
        setSearchResponse(resp);
        setRequestState(RequestState.SUCCEEDED);
      }).catch(error => {
        console.error('error fetching collection\n', error);
        setSearchResponse(null);
        setRequestState(RequestState.FAILED);
      });
    }
  }, [offeringType, requestState, searchAssets, searchQuery]);
  const {
    columns,
    mobileResultsSize
  } = useResponsiveProps({
    columns: {
      xs: 1,
      sm: 2,
      md: 3
    },
    mobileResultsSize: {
      xs: 2,
      md: maxColumns
    }
  });
  const totalResultsSize = useMemo(() => {
    return responsive ? mobileResultsSize : maxColumns;
  }, [mobileResultsSize, maxColumns, responsive]);
  const displayedResults = useMemo(() => {
    const results = searchResponse ? searchResponse.items : [];
    if (offeringId) {
      const filteredResults = results.filter(result => result.offeringId !== offeringId);
      if (totalResultsSize && filteredResults.length > totalResultsSize) {
        return filteredResults.slice(0, totalResultsSize);
      }
      return filteredResults;
    }
    return results;
  }, [offeringId, searchResponse, totalResultsSize]);
  if (displayedResults.length < 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    ErrorComponent: ErrorComponent,
    LoadingComponent: SectionLoadingComponent,
    requestStatus: requestState,
    children: /*#__PURE__*/_jsx(StorefrontSection, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(UICardGrid, {
        columns: columns,
        children: displayedResults.map((result, index) => /*#__PURE__*/_jsx(RouterAssetCard, {
          offeringType: result.offeringType,
          onClick: () => {
            trackCoreEvent('marketplaceClickResultItem', {
              action: 'click result item',
              type: result.offeringType === 'MODULE' ? 'module' : 'theme',
              value: result.slug,
              itemIndex: index,
              totalResults: displayedResults.length
            });
          },
          onTrackInteraction: trackInteraction,
          onTrackPageview: trackPageview,
          result: result,
          view: "grid"
        }, `result-${index}`))
      })
    }))
  });
}